import React from 'react';

import { useTranslation } from 'react-i18next';

import icon_black_hover from 'assets/img/icons/24px/tools-black-hover.svg';
import icon_black from 'assets/img/icons/24px/tools-black.svg';
import { featureFlags } from 'feature-flags';

import { IconButton } from 'components/buttons/icon-button-new-design';
import { FullwidthDropdown } from 'components/dropdown/fullwidth-dropdown';
import { DropdownTrigger } from 'components/dropdown/trigger';
import LocalizedLink from 'components/localized-link';

import type { DropDownList } from 'utils/links';

import { InternalFileType } from 'ts/types/file';

import type { IHeaderInteractor } from '../../interactor';
import s from './nav.module.scss';

interface IProps {
  interactor: IHeaderInteractor;
}

export const HeaderNav: React.FC<IProps> = ({ interactor }) => {
  const { t } = useTranslation();
  const renderList = React.useCallback(
    (list: DropDownList) => {
      return list.links.map((link, index) => {
        return (
          <LocalizedLink
            href={link.href}
            key={index}
            className={s.item}
          >
            <IconButton
              icon={link.icon}
              onClick={() =>
                interactor.convertDropDown.onClickHeaderFeature(
                  link.from,
                  link.to || InternalFileType.PDF,
                  link.href.slice(1)
                )
              }
            >
              {link.label}
            </IconButton>
          </LocalizedLink>
        );
      });
    },
    [interactor.convertDropDown]
  );

  return (
    <>
      <div className={s.dropDownTrigger}>
        <DropdownTrigger
          icon={icon_black}
          hoverIcon={icon_black_hover}
          label={t('header.dropdown.label')}
          isActive={interactor.convertDropDown.isOpen}
          onTrigger={interactor.convertDropDown.toggle}
          triggerRef={interactor.convertDropDown.triggerRef}
        />
      </div>
      <FullwidthDropdown
        isVisible={interactor.convertDropDown.isOpen}
        onClickOutside={interactor.convertDropDown.toggle}
        triggerRef={interactor.convertDropDown.triggerRef}
      >
        <div className={s.convertDropdown}>
          <div className={s.list}>
            <span>{interactor.links.tools.label}</span>
            {renderList(interactor.links.tools)}
          </div>
          {featureFlags.featureLandings && (
            <div className={s.list}>
              <span>{interactor.links.advancedTools.label}</span>
              {renderList(interactor.links.advancedTools)}
            </div>
          )}
        </div>
      </FullwidthDropdown>
    </>
  );
};
